import cookie from '../lib/cookie'
// import JSON from '../lib/json2'
import EVENTS from './upload-events'
// import sha256 from 'crypto-js/sha256';
import Cryptojs from '../lib/cryptojs';


function File(fileInfo, fileInput, settings) {
    var me = this;
    var jqDispatcher = $({});
    var jqXHR;

    me.load = function(url) {
        jqDispatcher.trigger(EVENTS.LOAD_COMPLETE, [fileInfo]);
    };
    me.on = function() {
        jqDispatcher.on.apply(jqDispatcher, arguments);
    };
    me.off = function() {
        jqDispatcher.off.apply(jqDispatcher, arguments);
    };
    me.send = function(fseq, fcks, chunkSize, params) {
        var startTime = new Date().valueOf();
        var chunk = fileInput.slice(chunkSize * fseq, Math.min(chunkSize * (fseq + 1), fileInput.size));
        var size = chunk.size / 1024;
        var formData = new FormData();
        for (var k in params) {
            formData.append(k, params[k]);
        }
        formData.append('chunk', chunk, 'chunk');
        jqXHR = $.ajax({
            xhrFields: {
                withCredentials: true
            },
            url: me.url || settings.url,
            type: "POST",
            data: formData,
            processData: false,
            contentType: false,
            crossDomain: true
        }).done(function(res) {
            try {
                if (typeof res === 'string') {
                    res = JSON.parse(res);
                }
                var duration = new Date().valueOf() - startTime;
                // 单位 KB/s
                var speed = size / (duration / 1000);
                jqDispatcher.trigger(EVENTS.UPLOAD_COMPLETE, [fileInfo, speed, res]);
            } catch (e) {
                jqDispatcher.trigger(EVENTS.UPLOAD_ERROR, [fileInfo, e]);
            }
        }).fail(function(jqXHR, textStatus, errorThrown) {
            jqDispatcher.trigger(EVENTS.UPLOAD_ERROR, [fileInfo, errorThrown]);
        });
    };
    me.stop = function() {
        if (jqXHR) jqXHR.abort();
        if ($(fileInput).parents('form')[0]) $(fileInput).parents('form')[0].reset();
        $(fileInput).parents('form').remove();
    };
}

function UploadRuntime () {
    var me = this;
    var files = [];
    var jqForm, jqFileInput, jqTarget;
    var jqDispatcher = $({});

    var getFuid = function(size, type, lastModifiedDate, username, name) {
        // console.log('MD5:',MD5)
        return Cryptojs.MD5(size + type + lastModifiedDate + username + name).toString();
    };

    var addForm = function() {
        if (jqForm) {
            jqForm.hide();
        }

        var id = 'upload-runtime-html5_' + new Date().valueOf();
        jqForm = $('<form><input id="' + id + '" type="file" class="upload-input-file"/></form>');
        jqFileInput = jqForm.find('#' + id);
        jqForm.width(0);
        jqForm.height(0);
        jqForm.css('overflow', 'hidden');
        $(document.body).append(jqForm);
    };

    me.init = function(s) {
        me.settings = s;
        jqTarget = $(s.target);
        addForm();
        $(document.body).on('change', '.upload-input-file', function() {
            me.onjqFileInputChange();
        }).on('click', s.target, function (evt) {
            evt.preventDefault();
            jqFileInput.trigger('click');
        });
    };
    me.check = function() {
        var xhr = new XMLHttpRequest();

        return typeof FormData === 'function' &&
            typeof Blob === 'function' &&
            typeof File === 'function' &&
            ('withCredentials' in xhr || typeof XDomainRequest === 'function');
    };
    me.on = function() {
        jqDispatcher.on.apply(jqDispatcher, arguments);
    };
    me.load = function(fuid, url) {
        if (files[fuid]) {
            if(!files[fuid].url) {
                files[fuid].url = url
            }
            files[fuid].load();
        }
    };
    me.setUrl = function(fuid, url) {
        if (files[fuid]) {
            files[fuid].url = url
        }
    },
    me.send = function(fuid, fseq, fcks, chunkSize, params) {
        if (files[fuid]) {
            files[fuid].send(fseq, fcks, chunkSize, params);
        }
    };
    me.stop = function(fuid) {
        if (files[fuid]) {
            files[fuid].off(EVENTS.UPLOAD_STARTED);
            files[fuid].off(EVENTS.LOAD_PROGRESS);
            files[fuid].off(EVENTS.LOAD_COMPLETE);
            files[fuid].off(EVENTS.UPLOAD_COMPLETE);
            files[fuid].off(EVENTS.UPLOAD_ERROR);
            files[fuid].stop();
            files[fuid] = null;
            delete files[fuid];
        }
    };
    me.show = function() {
        // No need...
    };
    me.hide = function() {
        // No need...
    };

    me.onjqFileInputChange = function() {
        var file = jqFileInput[0].files[0];
        var name = file.name;
        var size = file.size;
        var type = name.substring(name.lastIndexOf('.')) || '';
        var lastModifiedDate = file.lastModifiedDate;
        var fuid = getFuid(size, type, lastModifiedDate.valueOf(), cookie.get('username'), name);

        var fileInfo = {
            name: name,
            size: size,
            type: type,
            lastModifiedDate: file.lastModifiedDate,
            fuid: fuid
        };

        if (!files[fuid]) {
            files[fuid] = new File(fileInfo, file, me.settings);
            files[fuid].on(EVENTS.UPLOAD_STARTED, function(evt, fileInfo) {
                jqDispatcher.trigger(EVENTS.UPLOAD_STARTED, [fileInfo]);
            });
            files[fuid].on(EVENTS.LOAD_PROGRESS, function(evt, fileInfo, loaded) {
                jqDispatcher.trigger(EVENTS.LOAD_PROGRESS, [fileInfo, loaded]);
            });
            files[fuid].on(EVENTS.LOAD_COMPLETE, function(evt, fileInfo) {
                jqDispatcher.trigger(EVENTS.LOAD_COMPLETE, [fileInfo]);
            });
            files[fuid].on(EVENTS.UPLOAD_COMPLETE, function(evt, fileInfo, speed, res) {
                jqDispatcher.trigger(EVENTS.UPLOAD_COMPLETE, [fileInfo, speed, res]);
            });
            files[fuid].on(EVENTS.UPLOAD_ERROR, function(evt, fileInfo, msg) {
                jqDispatcher.trigger(EVENTS.UPLOAD_ERROR, [fileInfo, -999, msg]);
            });
        }

        jqDispatcher.trigger(EVENTS.FILE_SELECTED, [fileInfo]);

        addForm();
    };
};


export default UploadRuntime
